<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Use global element
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-global-element block="testimonials-widget" :locale="locale" v-model="element.object.global.enabled" @onGetValues="setGlobalValues" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Alt
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder="Image alt"
                            v-model="element.object.values.alt"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-full">
                        <label class="text-xs text-grey-darker">
                            Image
                        </label>
                        <app-field-file
                            class="reset mt-2"
                            v-model="element.object.values.image"
                            :types="{images: true, files: false}"
                        />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Testimonials widgets
                </div>
                <app-draggable :list="element.object.values.items" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.items.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.items"
                        class="draggable mb-4"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`Testimonial widget ${(index + 1)} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <app-cmp-trix-field
                            label="Message"
                            :classes="{ wrapper: { 'reset': true } }"
                            v-model="element.object.values.items[index].message"
                        />
                        <br>
                        <app-field-text
                            label="Author"
                            v-model="element.object.values.items[index].author"
                        />

                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no breadcrumb links.
                </p>

                <div class="px-4 text-right w-full">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import ColourField from '@/components/fields/inputs/Colour';;
    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';
    import ComposerTrixField from '@/components/composer/Fields/Trix';
    import FileField from '@/components/fields/inputs/File';

    import draggable from 'vuedraggable';

    import GlobalField from '@/components/composer/Fields/Global';
    import GlobalMixin from '@/components/composer/Mixins/Global';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-colour-field': ColourField,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-cmp-trix-field': ComposerTrixField,
            'app-field-file': FileField,
            'app-global-element': GlobalField
        },
        mixins: [ GlobalMixin ],
        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data: () => ({
            fields: {
                message: {
                    name: 'Message',
                    attribute: 'message'
                },
                author: {
                    name: 'Author',
                    attribute: 'author'
                },
                image: {
                    name: 'Image',
                    attribute: 'image'
                },
                alt: {
                    name: 'Alt',
                    attribute: 'alt'
                },
            },
        }),

        methods: {
            add() {
                console.log('ok')
                this.element.object.values.items.push({
                    'message': '',
                    'author': '',
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/TestimonialsWidgetSettings.vue